<template>
  <div style="display: flex;justify-content: center;padding: 100px;">
    <img src="../static/banner-set.png">
  </div>
</template>

<script>
export default {
  name: "isBuilding"
}
</script>

<style scoped>

</style>
